export const ROLES = {
  STUDENT: 'STUDENT',
  INSTRUCTOR: 'INSTRUCTOR',
  ADMIN: 'ADMIN',
  SUPERADMIN: 'SUPERADMIN',
} as const;

export type RoleType = typeof ROLES[keyof typeof ROLES];

export const DASHBOARD_ROUTES: Record<RoleType, string> = {
  [ROLES.STUDENT]: '/student/dashboard',
  [ROLES.INSTRUCTOR]: '/instructor/dashboard',
  [ROLES.ADMIN]: '/staff/dashboard',
  [ROLES.SUPERADMIN]: '/superadmin/dashboard',
};
